export default class CompositeCriteria {
  constructor() {
    this.criteriaList = [];
  }

  addCriteria(criteria) {
    this.criteriaList.push(criteria);
  }

  meetCriteria(items) {
    let result = items;

    this.criteriaList.forEach((criteria) => {
      result = criteria.meetCriteria(result);
    });

    return result;
  }
}
